export default __webpack_public_path__ + "static/media/Download-Play-Store.e4426361.png";